var React = require('react');

function CalculatorButtonIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.666667 0.333374H11.3333C11.7015 0.333374 12 0.631854 12 1.00004V13C12 13.3682 11.7015 13.6667 11.3333 13.6667H0.666667C0.29848 13.6667 0 13.3682 0 13V1.00004C0 0.631854 0.29848 0.333374 0.666667 0.333374ZM1.33333 1.66671V12.3334H10.6667V1.66671H1.33333ZM2.66667 3.00004H9.33333V5.66671H2.66667V3.00004ZM2.66667 7.00004H4V8.33337H2.66667V7.00004ZM2.66667 9.66671H4V11H2.66667V9.66671ZM5.33333 7.00004H6.66667V8.33337H5.33333V7.00004ZM5.33333 9.66671H6.66667V11H5.33333V9.66671ZM8 7.00004H9.33333V11H8V7.00004Z","fill":"black"}));
}

CalculatorButtonIcon.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none"};

module.exports = CalculatorButtonIcon;

CalculatorButtonIcon.default = CalculatorButtonIcon;
